import { useEffect } from "react";
import { useWidgetStore } from "./store/widget-store";
import { getWidgetKey } from "./lib/widget-key";
import { Bubble } from "./components/Bubble";
import { Panel } from "./components/Panel";

export function App() {
  const isOpen = useWidgetStore((state) => state.isOpen);
  const toggleOpen = useWidgetStore((state) => state.toggleOpen);
  const config = useWidgetStore((state) => state.config);
  const configStatus = useWidgetStore((state) => state.configStatus);
  const loadConfig = useWidgetStore((state) => state.loadConfig);

  const publicKey = getWidgetKey();

  useEffect(() => {
    if (!publicKey) return;
    void loadConfig(publicKey);
  }, [publicKey, loadConfig]);

  useEffect(() => {
    if (config?.brandColor) {
      document.documentElement.style.setProperty(
        "--koomarce-brand",
        config.brandColor
      );
    }
  }, [config?.brandColor]);

  // This page always runs inside the iframe the loader script (public/
  // widget.js) injects into the seller's page. The loader controls the
  // iframe's actual on-screen size, so it needs to know whenever the panel
  // opens/closes to resize between "just the bubble" and the full panel -
  // targetOrigin is "*" since the seller's page origin is arbitrary/unknown
  // to this app, and the payload carries nothing sensitive.
  useEffect(() => {
    window.parent.postMessage({ source: "koomarce-widget", type: "resize", isOpen }, "*");
  }, [isOpen]);

  if (!publicKey) {
    // Loaded outside a properly-configured embed (no ?key= in the iframe
    // src) - fail visibly rather than showing a broken/misleading bubble.
    return (
      <div className="flex h-screen items-center justify-center p-4 text-center text-sm text-red-500">
        Missing widget key.
      </div>
    );
  }

  if (configStatus === "error") {
    return (
      <div className="flex h-screen items-center justify-center p-4 text-center text-sm text-red-500">
        This widget isn't available right now.
      </div>
    );
  }

  return (
    <div className="flex h-screen items-end justify-end p-4">
      {isOpen ? <Panel /> : <Bubble onClick={toggleOpen} />}
    </div>
  );
}
